"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var lodash_1 = __importDefault(require("lodash"));
var TranslationContext = react_1.createContext({
    getTranslation: lodash_1.default.identity,
    currentLanguage: 'en',
    formatDuration: lodash_1.default.identity,
    setCurrentLanguage: lodash_1.default.identity,
});
exports.TranslationProvider = TranslationContext.Provider;
exports.default = TranslationContext;
//# sourceMappingURL=translations.context.js.map